import {VGLawCookie} from "vglawcookie";

let lastScrollTop = 0,
	$body = $('body'),
	crumbs_opacity = .6;

window.VegasListener = {
	onReady: () => {
		Vegas.typed();
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.flashlight();
		Vegas.fixedHeader($(window));
		Vegas.fixedBreadcrumbs($(window));
		Vegas.fixedScrollTo($(window));
		Vegas.inputFiles();
		Vegas.preloader();
		Vegas.fancybox();
	},

	onLoad: () => {

	},

	onClick: () => {
		Vegas.popup();
	},

	onSubmit: () => {

	},

	onScroll: ($self) => {
		Vegas.fixedHeader($self);
		Vegas.fixedBreadcrumbs($self);
		Vegas.fixedScrollTo($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},
	preloader: function () {
		$(".vg-loader").fadeOut(300, function () {
			$("#wrapper").animate({
				opacity: 300
			}, 1);

			if ($(window).scrollTop() <= 370) {
				$("header").delay(50).css('top', 0);
			}
		});
	},
	enablePlugins: function () {
		// vg nav;
		$(".vg-nav").vegasMenu();

		// niceSelect;
		$('[data-toggle=tooltip]').tooltip();

		//
		new VGLawCookie();
	},
	popup: function () {
		$('[data-modal]').click(function () {
			let target = $(this).data('modal'),
				$modal = $(target),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false;

			$body.attr('data-modal-open', target);

			if (title) {
				$modal.find('.modal-title').text(title);
			}

			if (id) {
				$modal.find('form input[name=id]').val(id);
			}

			let data = $(this).data();
			for (let key in data) {
				let value = data[key];
				$modal.find('input[data-' + key + ']').val(value);
			}

			$(target).modal('show');

			if ($(this).data('events-cancel'))
				return false;
		});

		$('.modal').on('hidden.bs.modal', function (e) {
			$body.removeAttr('data-modal-open');
		});
	},
	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},
	typed: function () {
		vgTyped.init('[data-typed]')
	},
	other: function () {
		// default page
		let $pageText = $('.page-default');
		$pageText.find('table').addClass('table table-hover table-striped');
		$pageText.find('br').after('<span class="mb-15 d-block"></span>');
	},
	flashlight: function () {
		let $serviceItem = $('.vg-services-item > a');

		function isIOs() {
			return [
					'iPad Simulator',
					'iPhone Simulator',
					'iPod Simulator',
					'iPad',
					'iPhone',
					'iPod'
				].includes(navigator.platform)
				// iPad on iOS 13 detection
				|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
		}

		if (isIOs()) {
			$serviceItem.addClass('isIOs')
		} else {
			$serviceItem.mousemove(function (e) {
				let x = e.pageX - $(this).offset().left;
				let y = e.pageY - $(this).offset().top;

				$(this).css({
					'backgroundImage': `radial-gradient(130px at ${x}px ${y}px, #163675 0%, #163675 100%, #343434 100%)`
				});
			});

			$serviceItem.mouseout(function (e) {
				$(this).css({
					'backgroundImage': `none`
				});
			});
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-header'),
			scroll = $self.scrollTop();

		let $bg_overlay = $(".vg-breadcrumbs-overlay"),
			opacity = crumbs_opacity + (scroll / 1500);

		const [title, content] = [$('.reviews-area .title'), $('.reviews-area .content-area')];

		$bg_overlay.css({
			'opacity': opacity >= .95 ? .95 : opacity,
		});

		if (scroll > 345) {
			$body.addClass('vg-hdr--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -80).removeClass('is-active');
				$body.removeClass('vg-hdr--is-fixed');
				title.removeClass('fixed');
				content.removeClass('fixed');
			} else {
				$sticky.css('top', 0).addClass('is-active');
				$body.addClass('vg-hdr--is-fixed');
				title.addClass('fixed');
				content.addClass('fixed');
			}

			lastScrollTop = scroll;
		} else if (scroll === 0) {
			$sticky.css('top', 0).removeClass('is-active vg-hdr--is-fixed vg-hdr--is-scroll');
		} else {
			$sticky.css('top', -80);
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}
	},

	fixedBreadcrumbs: function ($self) {
		let $sticky = $('.vg-breadcrumbs__links'),
			scroll = $self.scrollTop();

		if ($sticky.length) {
			if (scroll > 300) {
				$body.addClass('vg-breadcrumbs--is-scroll');
				$sticky.addClass('vg-breadcrumbs--fixed');

				if ($body.hasClass('vg-hdr--is-fixed')) {
					$sticky.css('top', 80)
				} else {
					$sticky.css('top', 0)
				}
			} else {
				$sticky.removeClass('vg-breadcrumbs--fixed');
				$body.removeClass('vg-breadcrumbs--is-scroll');
			}
		}
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	inputFiles: function () {
		$('[type=file]').change(function () {
			let $self = $(this),
				$file_info = $self.closest('.vg-files').find('.vg-files__info'),
				$file_info_name = $file_info.find('.vg-files__name');

			$file_info_name.find('span').remove();

			if ($self.val() !== '') {
				let files = $(this)[0].files;

				$file_info.fadeIn().css('display', 'block');
				$file_info.find('.vg-files__info__count').text('Выбрано файлов: ' + files.length);

				for (let i = 0; i <= files.length - 1; i++) {
					$file_info_name.append('<span>- ' + files[i].name + '</span>');
				}
			}

			return false;
		});
	},

	fancybox: function (target = "[data-fancybox]", params = {}) {
		fbx.Fancybox.bind(target, Object.assign(params, {
			Image: {
				zoom: false,
			}
		}));
	},
};